/* eslint-disable jsx-a11y/alt-text */
import GreenTriangle from "assets/iconsSVG/greenTriangle";
import React from "react";
// import { useHistory } from "react-router-dom";

import BlueMark from "../../assets/iconsSVG/blueMark";
import GreenMark from "../../assets/iconsSVG/greenMark";
import GreenTriangle2 from "../../assets/iconsSVG/greenTriangle2";
import SellItLogo from "../../assets/iconsSVG/sellitLogo";
import GradientImage from "../../assets/logo/gradientImage.png";
import MobileApp from "../../assets/logo/mobileApp.png";
import StripedCircle from "../../assets/logo/stripedCircle.png";
import ButtonRedirect from "./components/ButtonRedirect";
import * as S from "./styles";

const mobileRedirect: React.FC = () => {
  return (
    <S.Container>
      <S.PositionGreenMark>
        <GreenMark />
      </S.PositionGreenMark>
      <S.PositionLogo>
        <SellItLogo />
      </S.PositionLogo>
      <S.BottomMarks>
        <BlueMark />
        <img
          src={StripedCircle}
          style={{ height: 95, width: 95, marginTop: 30 }}
        />
        <S.PositionGreenTriangle>
          <GreenTriangle />
        </S.PositionGreenTriangle>
      </S.BottomMarks>
      <S.Content>
        <S.ContentLeft>
          <S.TextContent>
            <S.Text>Baixe o </S.Text>
            <S.TextGreen>App</S.TextGreen>
            <S.Text>do Sell.it</S.Text>
          </S.TextContent>
          <S.TextContent>
            <S.Text>
              <S.TextGreen>no seu celular</S.TextGreen>
            </S.Text>
          </S.TextContent>
          <S.Margin />
          <S.PositionButtons>
            <ButtonRedirect
              buttonType="PlayStore"
              href="https://play.google.com/store/apps/details?id=com.cyrela.sellit"
            />
            <S.Margin />
            <ButtonRedirect
              buttonType="AppStore"
              href="https://apps.apple.com/br/app/sell-it-agenda-de-corretores/id1583818111"
            />
          </S.PositionButtons>
          <div style={{ display: "flex", flex: 1 }} />
          <S.GradientPosition>
            <img src={GradientImage} style={{ height: 167, width: 128 }} />
            <GreenTriangle2 />
          </S.GradientPosition>
        </S.ContentLeft>
        <S.ContentRight>
          <img src={MobileApp} style={{ height: 373, width: 134 }} />
        </S.ContentRight>
      </S.Content>
    </S.Container>
  );
};

export default mobileRedirect;
